var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNotYetAvailable = function SvgNotYetAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.657 22.521v-8.884c0-4.504 4.46-13.36 14.023-13.36 9.563 0 14.398 8.05 14.398 13.361v8.883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.319 21.131h43.098v36.146H1.319z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M23.563 35.157v6.703"
  }))));
};
export default SvgNotYetAvailable;